<template>
  <div>
    <!-- 主内容区 -->
    <div class="products-container">
      <!-- 主要内容区域 -->
      <div class="main-content">
        <!-- 左侧产品图片展示区 -->
        <div class="product-images">
          <div class="main-image">
            <img :src="currentImageUrl" alt="产品图片" class="main-product-image">
          </div>
        </div>

        <!-- 右侧产品信息区 -->
        <div class="product-info">
          <div class="product-selection">
            <h2 class="section-title">{{ $t('products.ProductSelection') }}</h2>
            <div class="selection-buttons">
              <button class="selection-btn" :class="{active: currentProduct === 'express'}" @click="selectProduct('express')">{{ $t('products.MRTExpress') }}</button>
              <button class="selection-btn" :class="{active: currentProduct === 'ultra'}" @click="selectProduct('ultra')">{{ $t('products.MRTUltra') }}</button>
            </div>
          </div>

          <div class="product-description" v-if="currentProduct !== 'compatibility'">
            <h3 :style="{color: textStyles.titleColor}">{{ currentProduct === 'express' ? $t('products.MRTExpress') : $t('products.MRTUltra') }}</h3>
            <p class="description-text" :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ currentProduct === 'express' ? $t('products.ExpressDescription') : $t('products.UltraDescription') }}</p>
          </div>

          <!-- 版本选择下拉框 -->
          <div class="action-buttons">
            <div class="version-selector">
              <label for="version-select">{{ $t('products.SelectVersion') }}：</label>
              <select id="version-select" v-model="currentVersion" class="version-dropdown">
                <option value="network">{{ $t('products.NetworkFullVersion') }}</option>
                <option value="standalone">{{ $t('products.StandaloneFullVersion') }}</option>
                <option value="repair">{{ $t('products.StandaloneRepairVersion') }}</option>
              </select>
            </div>
          </div>

          <!-- 版本描述区域 -->
          <div class="version-description" v-if="currentProduct !== 'compatibility'">
            <h4 :style="{color: textStyles.subtitleColor}">{{ currentVersion === 'network' ? $t('products.NetworkFullVersion') : currentVersion === 'standalone' ? $t('products.StandaloneFullVersion') : $t('products.StandaloneRepairVersion') }}{{ $t('products.Introduction') }}</h4>
            <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ currentVersion === 'network' ? (currentProduct === 'express' ? $t('products.NetworkFullVersionDescExpress') : $t('products.NetworkFullVersionDescUltra')) : currentVersion === 'standalone' ? $t('products.StandaloneFullVersionDesc') : $t('products.StandaloneRepairVersionDesc') }}</p>
          </div>
        </div>
      </div>

      <!-- 详情标签页 -->
      <div class="details-tabs" v-if="currentProduct !== 'compatibility'">
        <div class="tabs-header">
          <button class="tab-btn" :class="{active: currentTab === 'overview'}" @click="currentTab = 'overview'">{{ $t('products.ProductOverview') }}</button>
          <button class="tab-btn" :class="{active: currentTab === 'hardware'}" @click="currentTab = 'hardware'">{{ $t('products.ProductSpecifications') }}</button>
          <button class="tab-btn" :class="{active: currentTab === 'software'}" @click="currentTab = 'software'">{{ $t('products.SoftwareOverview') }}</button>
        </div>
        <div class="tabs-content">
          <div class="tab-pane" v-show="currentTab === 'overview'">
            <h3 :style="{color: textStyles.titleColor}">{{ currentProduct === 'express' ? $t('products.MRTExpress') : $t('products.MRTUltra') }} {{ $t('products.ProductOverview') }}</h3>
            <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ currentProduct === 'express' ? $t('products.ExpressOverview') : $t('products.UltraOverview') }}</p>
          </div>
          <div class="tab-pane" v-show="currentTab === 'hardware'">
            <h3>{{ currentProduct === 'express' ? $t('products.MRTExpress') : $t('products.MRTUltra') }} {{ $t('products.ProductSpecifications') }}</h3>
            <div class="hardware-grid">
              <div class="hardware-item" v-for="(item, index) in hardwareImages[currentProduct]" :key="index" @click="enlargeImage(item.image)">
                <img :src="item.thumbnail" :alt="$t('products.HardwareImages.' + item.key)" class="hardware-image">
                <p class="hardware-name">{{ $t('products.HardwareImages.' + item.key) }}</p>
              </div>
            </div>
          </div>
          <div class="tab-pane" v-show="currentTab === 'software'">
            <div class="software-carousel">
              <div class="carousel-container">
                <img :src="currentSoftwareImage" alt="软件截图" class="carousel-image">
              </div>
              <button class="carousel-btn prev-btn" @click="prevSoftwareImage">&lt;</button>
              <button class="carousel-btn next-btn" @click="nextSoftwareImage">&gt;</button>
              <div class="carousel-indicators">
                <span class="indicator" v-for="(img, index) in softwareImages" :key="index" :class="{active: currentSoftwareIndex === index}" @click="goToSoftwareImage(index)"></span>
              </div>
            </div>
            <div class="software-features">
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.MRTMainInterface') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.MainInterfaceDesc') }}</p>
              </div>
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.CommonToolsModule') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.CommonToolsDesc') }}</p>
              </div>
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.DataRecoveryToolModule') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.DataRecoveryDesc') }}</p>
              </div>
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.WesternDigitalModule') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.WesternDigitalDesc') }}</p>
              </div>
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.SeagateModule') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.SeagateDesc') }}</p>
              </div>
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.HitachiModule') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.HitachiDesc') }}</p>
              </div>
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.ToshibaModule') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.ToshibaDesc') }}</p>
              </div>
              <div class="feature-box">
                <h4 :style="{color: textStyles.subtitleColor, fontSize: '20px', fontWeight: 'bold'}">{{ $t('products.MaxtorModule') }}</h4>
                <p :style="{color: textStyles.descriptionColor, whiteSpace: 'pre-line'}">{{ $t('products.MaxtorDesc') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 图片放大模态框 -->
    <div class="modal-overlay" v-if="showModal" @click="closeModal">
      <div class="modal-content" @click.stop>
        <button class="close-modal-btn" @click="closeModal">&times;</button>
        <img :src="enlargedImage" alt="放大图片" class="modal-image">
      </div>
    </div>
  </div>
</template>

<script>
import { hardwareImages, softwareImages, softwareFeatures, productDescriptions, versionOptions, textStyles } from '@/data/productData.js';

export default {
  name: 'products',
  data() {
    return {
      currentProduct: 'express', // 默认显示MRT Express
      currentImageIndex: 0,
      currentImageUrl: '',
      currentTab: 'overview', // 默认显示概述标签
      
      // 从外部导入的数据
      hardwareImages,
      softwareImages,
      softwareFeatures,
      productDescriptions,
      versionOptions,
      textStyles, // 导入文本样式配置
      
      currentSoftwareIndex: 0,
      currentSoftwareImage: '',
      showModal: false,
      enlargedImage: '',
      // 当前选中的版本，默认是网络版
      currentVersion: 'network'
    }
  },
  created() {
    // 初始化当前图片
    this.currentImageUrl = this.hardwareImages[this.currentProduct][0].thumbnail;
    // 初始化软件轮播图
    this.currentSoftwareImage = this.softwareImages[0];
    // 确保导航高亮正确
    sessionStorage.setItem('menuIndex', '');
  },
  methods: {
    // 选择产品
    selectProduct(product) {
      this.currentProduct = product;
      this.currentImageIndex = 0;
      if (product !== 'compatibility') {
        this.currentImageUrl = this.hardwareImages[product][0].thumbnail;
      }
    },
    // 设置当前显示图片
    setCurrentImage(img, index) {
      this.currentImageUrl = img;
      this.currentImageIndex = index;
    },
    // 软件轮播图控制方法
    prevSoftwareImage() {
      this.currentSoftwareIndex = (this.currentSoftwareIndex - 1 + this.softwareImages.length) % this.softwareImages.length;
      this.currentSoftwareImage = this.softwareImages[this.currentSoftwareIndex];
    },
    nextSoftwareImage() {
      this.currentSoftwareIndex = (this.currentSoftwareIndex + 1) % this.softwareImages.length;
      this.currentSoftwareImage = this.softwareImages[this.currentSoftwareIndex];
    },
    goToSoftwareImage(index) {
      this.currentSoftwareIndex = index;
      this.currentSoftwareImage = this.softwareImages[this.currentSoftwareIndex];
    },
    // 图片放大功能
    enlargeImage(url) {
      this.enlargedImage = url;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<style scoped lang="less">
@import '../assets/css/varibles';
@import '../assets/css/mixins';



/* 容器样式 */
.products-container {
  min-height: 100vh;
  background-color: white;
}

/* 导航栏样式 */
.nav-container {
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.nav-inner {
  width: 1170px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.logo {
  height: 40px;
  margin-right: 40px;
}

.nav-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  position: relative;
  display: inline-block;
  margin-right: 20px;
}

.menu-text {
  display: block;
  padding: 10px 15px;
  color: #333;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    color: @active-color;
  }
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 150px;
}

.dropdown-item {
  padding: 10px 15px;
  color: #333;
  cursor: pointer;
  &:hover {
    background-color: @active-color;
    color: #fff;
  }
}

/* 主要内容区域 */
.main-content {
  width: 1170px;
  margin: 30px auto;
  display: flex;
  gap: 30px;
}

/* 左侧产品图片展示区 */
.product-images {
  flex: 1;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.main-image {
  text-align: center;
  margin-bottom: 20px;
}

.main-product-image {
  max-width: 100%;
  max-height: 400px;
  border-radius: 4px;
}

.thumbnails {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.thumbnail-item {
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  transition: all 0.3s ease;
  &:hover,
  &.active {
    border-color: @active-color;
  }
}

.thumbnail {
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 2px;
}

/* 右侧产品信息区 */
.product-info {
  flex: 1;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.product-selection {
  margin-bottom: 30px;
}

.section-title {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.selection-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.selection-btn {
  padding: 12px 20px;
  background-color: #f0f0f0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
  &:hover {
    background-color: #e0e0e0;
  }
  &.active {
    background-color: @active-color;
    color: #fff;
  }
}

.product-description h3 {
  font-size: 24px;
  margin-bottom: 15px;
  color: #333;
}

.description-text {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

.compatibility-list h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.compatibility-list ul {
  list-style: none;
  padding: 0;
}

.compatibility-list li {
  padding: 8px 0;
  font-size: 15px;
  color: #666;
  position: relative;
  padding-left: 20px;
  &::before {
    content: '•';
    color: @active-color;
    position: absolute;
    left: 0;
  }
}

.action-buttons {
  margin-top: 30px;
}

.reserve-btn {
  padding: 12px 30px;
  background-color: @active-color;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: darken(@active-color, 10%);
  }
}

/* 详情标签页 */
.details-tabs {
  width: 1170px;
  margin: 30px auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

.tabs-header {
  display: flex;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.tab-btn {
  padding: 15px 30px;
  background-color: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #666;
  transition: all 0.3s ease;
  &:hover {
    color: @active-color;
  }
  &.active {
    color: @active-color;
    border-bottom-color: @active-color;
    background-color: #fff;
  }
}

.tabs-content {
  padding: 30px;
}

.tab-pane h3 {
  font-size: 22px;
  margin-bottom: 20px;
  color: #333;
}

.tab-pane p {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

.tab-pane ul {
  list-style: none;
  padding: 0;
}

.tab-pane li {
  padding: 10px 0;
  font-size: 15px;
  color: #666;
  position: relative;
  padding-left: 20px;
  &::before {
    content: '•';
    color: @active-color;
    position: absolute;
    left: 0;
  }
}

/* 版本选择样式 */
.version-selector {
  margin-top: 20px;
}

.version-selector label {
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  color: #333;
}

.version-dropdown {
  width: 100%;
  padding: 10px 15px;
  font-size: 16px;
  border: 2px solid @active-color;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  &:focus {
    outline: none;
    border-color: darken(@active-color, 10%);
    box-shadow: 0 0 5px rgba(0, 150, 136, 0.2);
  }
}

/* 版本描述样式 */
.version-description {
  margin-top: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.version-description h4 {
  color: @active-color;
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
}

.version-description p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 0;
}

/* 产品规格图片网格布局 */
.hardware-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px; /* 增加方框之间的间隔 */
  margin-top: 20px;
}

.hardware-item {
  text-align: center;
  cursor: pointer;
  border: 2px solid #ddd; /* 添加方框边框 */
  border-radius: 8px; /* 圆角边框 */
  padding: 15px; /* 内部间距 */
  background-color: white; /* 背景色 */
  transition: all 0.3s ease; /* 过渡效果 */
  &:hover {
    border-color: @active-color; /* 鼠标悬停时边框变色 */
    box-shadow: 0 4px 12px rgba(0,0,0,0.1); /* 添加阴影效果 */
  }
}

.hardware-image {
  width: 100%;
  height: 180px; /* 增加图片高度 */
  object-fit: contain;
  margin-bottom: 10px;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
}

.hardware-name {
  margin: 10px 0 0 0;
  color: #333;
  font-size: 16px; /* 增大字体 */
  font-weight: 500;
}

/* 软件轮播图样式 */
.software-carousel {
  position: relative;
  margin: 20px 0;
  height: 400px;
  overflow: hidden;
}

.carousel-container {
  width: 100%;
  height: 100%;
  text-align: center;
}

.carousel-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  &:hover {
    background: rgba(0,0,0,0.7);
  }
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255,255,255,0.5);
  cursor: pointer;
  &.active {
    background: white;
  }
}

/* 软件功能介绍样式 */
.software-features {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-top: 30px;
}

.feature-box {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.feature-box h4 {
  color: @active-color;
  margin-top: 0;
  margin-bottom: 10px;
}

.feature-box p {
  color: #666;
  line-height: 1.6;
}

.feature-detail-btn {
  background: transparent;
  color: @active-color;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  &:after {
    content: '→';
    margin-left: 5px;
  }
}

/* 图片放大模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.modal-image {
  max-width: 100%;
  max-height: 90vh;
  border: 4px solid white;
}

.close-modal-btn {
  position: absolute;
  top: -20px;
  right: -20px;
  background: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
}

/* 历史版本列表样式 */
.history-versions {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 15px;
}

.history-version-item {
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: white;
}



/* 响应式设计 */
@media screen and (max-width: 1200px) {
  .nav-inner,
  .main-content,
  .details-tabs,
  .selector-container,
  .terminal-content,
  .equalizer-content {
    width: 95%;
  }
}

@media screen and (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .thumbnails {
    flex-wrap: wrap;
  }

  .tab-btn {
    padding: 12px 20px;
    font-size: 14px;
  }

  .tabs-content {
    padding: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/products.vue